import MainLayout from "@/components/layout/MainLayout";
import { useTranslation } from "react-i18next";

export const RecordNotFound = () => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <div className="container-page">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 max-w-2xl mx-auto mt-8">
          <h2 className="font-medium text-yellow-800 mb-2 text-xl">{t('records.not_found.title')}</h2>
          <p className="text-yellow-700">{t('records.not_found.description')}</p>
        </div>
      </div>
    </MainLayout>
  );
};